import { CardRow } from 'components/CardRow';
import { ICONS } from 'components/Icon';
import { format, isDate } from 'date-fns';
import { API_TIME_FORMAT } from 'lib/constants';
import React from 'react';
import { BUTTON_BORDER_RADIUS, BUTTON_HEIGHT } from 'components/Button';
import { TEXT_SIZE_NORMAL } from 'components/Txt';
import { FontFamilyRegular, theme } from 'lib/theme';

const TimeFieldWidth = 120;

interface Props {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  clearable?: boolean;
  placeholder?: string;
  enforceInputWidth?: boolean;
}

export const TimeField: React.FC<Props> = React.memo(
  ({
    label,
    onChange,
    placeholder,
    clearable = true,
    value,
    enforceInputWidth = false,
  }) => {
    const handleChange = React.useCallback(
      (newValue: Date | '') => {
        const finalValue = newValue ? new Date(newValue) : '';
        if (isDate(finalValue)) {
          onChange(format(finalValue, API_TIME_FORMAT));
        } else if (clearable) {
          onChange('');
        }
      },
      [clearable, onChange],
    );

    const handleChangeEvent = React.useCallback(
      (event: React.ChangeEvent<HTMLInputElement>) => {
        const { value: newValue } = event.target;
        handleChange(newValue ? new Date(`2020-01-01T${newValue}`) : '');
      },
      [handleChange],
    );

    const shouldShowClearButton = clearable && !!value;
    return (
      <CardRow
        label={label}
        labelStyle={{ flex: 0 }}
        style={{
          backgroundColor: theme.colors.white,
        }}
        contentStyle={{
          paddingVertical: 0,
        }}
        actionIcon={ICONS.CircleXmarkLight}
        onAction={shouldShowClearButton ? () => handleChange('') : undefined}
        navigationType="time-picker"
      >
        <input
          type="time"
          onChange={handleChangeEvent}
          value={value}
          placeholder={placeholder}
          required={!clearable}
          style={{
            height: BUTTON_HEIGHT - 2,
            borderColor: theme.colors.blue,
            borderWidth: 1,
            borderStyle: 'solid',
            borderRadius: BUTTON_BORDER_RADIUS,
            paddingRight: 4,
            paddingLeft: 4,
            fontFamily: FontFamilyRegular,
            fontSize: TEXT_SIZE_NORMAL,
            width: enforceInputWidth ? TimeFieldWidth - 10 : undefined,
          }}
        />
      </CardRow>
    );
  },
);
